var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentColorWarning20({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5433 8.35575C28.2473 5.21475 32.7563 5.21475 34.4573 8.35575L53.9573 44.3617C54.3273 45.0466 54.5133 45.8158 54.4972 46.5941C54.4811 47.3724 54.2633 48.1331 53.8652 48.8021C53.4671 49.471 52.9022 50.0253 52.2259 50.4106C51.5495 50.796 50.7847 50.9993 50.0063 51.0007H10.9943C10.2145 51.0009 9.448 50.7985 8.77 50.4132C8.092 50.028 7.52575 49.4731 7.12677 48.8031C6.72778 48.1331 6.50976 47.3709 6.49407 46.5913C6.47839 45.8116 6.66558 45.0413 7.03729 44.3557L26.5433 8.35575Z",
    fill: "url(#paint0_linear_8_22044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.5C32 22.1022 31.842 21.7206 31.5607 21.4393C31.2794 21.158 30.8978 21 30.5 21C30.1022 21 29.7206 21.158 29.4393 21.4393C29.158 21.7206 29 22.1022 29 22.5V34.5C29 34.8978 29.158 35.2794 29.4393 35.5607C29.7206 35.842 30.1022 36 30.5 36C30.8978 36 31.2794 35.842 31.5607 35.5607C31.842 35.2794 32 34.8978 32 34.5V22.5Z",
    fill: "url(#paint1_linear_8_22044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 43.5C31.0967 43.5 31.669 43.2629 32.091 42.841C32.5129 42.419 32.75 41.8467 32.75 41.25C32.75 40.6533 32.5129 40.081 32.091 39.659C31.669 39.2371 31.0967 39 30.5 39C29.9033 39 29.331 39.2371 28.909 39.659C28.4871 40.081 28.25 40.6533 28.25 41.25C28.25 41.8467 28.4871 42.419 28.909 42.841C29.331 43.2629 29.9033 43.5 30.5 43.5Z",
    fill: "url(#paint2_linear_8_22044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_22044",
    x1: 13.9913,
    y1: -1.03125,
    x2: 42.4163,
    y2: 56.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_22044",
    x1: 24.5,
    y1: 21,
    x2: 35.309,
    y2: 44.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_22044",
    x1: 24.5,
    y1: 21,
    x2: 35.309,
    y2: 44.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentColorWarning20);
export default __webpack_public_path__ + "static/media/fluent-color_warning-20.330f4429dc1e335bc79a1bde13f456e3.svg";
export { ForwardRef as ReactComponent };